import { useSelector } from "react-redux";
import { useCallback } from "react";
import { getAddedAncillariesExtraProduct, preOptedToAddedAncillaries } from "../store/selectors/getAddedAncillariesExtraProduct.js";
import usePaxWithBaggages from "./usePaxWithBaggages.js";
import { objectUtils, pricingUtils } from "@flights/web-api-utils-universal";
import { getFlight } from "../store/flightDetails/selectors.js";
import { getMetaFlight } from "../store/metaFlightDetails/selectors.js";
import { getExtraProducts, getSelectedExtraProducts, getPreOptedAncillaries } from "../ancillaries/store/extraProducts/selectors.js";
import { getCartDetails } from "../store/cartDetails/selectors.js";
const usePriceBreakDownForPreOptedAncillaries = (flightFromProp) => {
    const { isPaxWithBaggages } = usePaxWithBaggages();
    const flightDetailsFlght = useSelector(getFlight);
    const metaFlight = useSelector(getMetaFlight);
    const extraProducts = useSelector(getExtraProducts);
    const selected = useSelector(getSelectedExtraProducts);
    const preOptedAncillaries = useSelector(getPreOptedAncillaries);
    const cartDetails = useSelector(getCartDetails);
    const flightFromStore = flightDetailsFlght || metaFlight;
    const flight = flightFromProp || flightFromStore;
    const getAncillaries = useCallback(() => {
        if (isPaxWithBaggages) {
            return {
                ...cartDetails?.cart.extras,
                ...getAddedAncillariesExtraProduct(extraProducts, selected),
                ...(flight ? preOptedToAddedAncillaries(preOptedAncillaries, flight) : {})
            };
        }
        return flight ? preOptedToAddedAncillaries(preOptedAncillaries, flight) : {};
    }, [flight, extraProducts, selected, preOptedAncillaries, cartDetails, isPaxWithBaggages]);
    const getPreOptedAncillariesFn = () => (flight ? preOptedToAddedAncillaries(preOptedAncillaries, flight) || {} : {});
    const getTotalPrice = useCallback((basePrice, ancillaries) => {
        let total = basePrice || pricingUtils.getEmptyBreakdown();
        if (!flight)
            return total;
        const flightBasePrice = flight.priceBreakdown;
        const selectedAncillaries = ancillaries || getAncillaries();
        const availableAncillaries = flight.ancillaries;
        if (selectedAncillaries && availableAncillaries) {
            const ancillaryPrices = Object.keys(selectedAncillaries)
                .map((item) => {
                const price = selectedAncillaries[item].price;
                if (price) {
                    return { ...price, showPriceStrikethrough: false };
                }
                return price;
            })
                .filter(Boolean);
            total = pricingUtils.sumPriceBreakdown([flightBasePrice, ...ancillaryPrices]);
        }
        else {
            total = flightBasePrice;
        }
        return total;
    }, [flight, getAncillaries]);
    const getTotalPriceFromCart = useCallback(() => {
        let total = pricingUtils.getEmptyBreakdown();
        if (!flight || !cartDetails?.cart.price)
            return total;
        const cartBasePrice = cartDetails.cart.price;
        const selectedAncillaries = getAncillaries();
        const availableAncillaries = flight.ancillaries;
        if (selectedAncillaries && availableAncillaries) {
            const ancillaryPrices = objectUtils
                .getObjectKeys(selectedAncillaries)
                .flatMap((ancillaryKey) => selectedAncillaries[ancillaryKey])
                .map((selectedAncillary) => {
                if (selectedAncillary?.price) {
                    return { ...selectedAncillary.price, showPriceStrikethrough: false };
                }
                return selectedAncillary?.price;
            })
                .filter((selectedAncillaryPrice) => !!selectedAncillaryPrice);
            total = pricingUtils.sumPriceBreakdown([cartBasePrice, ...ancillaryPrices]);
        }
        else {
            total = cartBasePrice;
        }
        return total;
    }, [flight, getAncillaries, cartDetails]);
    return {
        getAncillaries,
        getPreOptedAncillaries: getPreOptedAncillariesFn,
        getTotalPrice,
        getTotalPriceFromCart
    };
};
export default usePriceBreakDownForPreOptedAncillaries;
